@use "../../styles/breakpoint.module.scss" as *;

.form {
    margin-top: var(--spacer-40);
    grid-column: col-start 3 / span 8;

    @media ($below-tablet) {
        grid-column: content;
    }

    button {
        inset-block: 28px;
        right: 28px;

        svg {
            width: 24px;
            height: 24px;
        }
    }
}

.counter {
    composes: fontST16 from "../../styles/typography.module.scss";
    grid-column: col-start 3 / span 8;
    margin-top: var(--spacer-24);

    @media ($below-tablet) {
        grid-column: content;
    }
}

.loadMore {
    composes: buttonPrimary from "../Clickables/index.module.scss";
    box-shadow: var(--box-shadow-1);
    margin-bottom: var(--spacer-12);
}

.spacer {
    grid-column: margin;
    margin-block: var(--spacer-40);
    height: 1px;
    background: var(--mid-gray);
}
